// Copyright (c) 2017 Deere & Company

// strips only leading and trailing spaces

export const stripSpaces = string => string.replace(/^(\s|\u200b)+|(\s|\u200b)+$/g, '');

// strips all the spaces

export const stripAllSpaces = string => string.replace(/\s/g, '');



// WEBPACK FOOTER //
// ./src/shared/services/strip-spaces.js